import React, { useEffect, useState } from "react";
import {
  Col,
  Card,
  Table,
  Modal,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
const RiderCommission = () => {
  const history=useHistory()
  const [clintcommission, setallclintcomminission] = useState([]);
  const [category, setCategory] = useState([{ category: "" }]);
  const [spinner, setSpinner] = useState(true);
  const [riderCommission, setridercommission] = useState("");
  const [clientCommisionOnline, setClientCommisionOnline] = useState("");
  const [cid, setcid] = useState("");
  const [edit, setalledit] = useState([
    {
      category: "",
      _id: "",
      RiderCommission: "",
      ClientCommission: "",
      ClientCommissionOnline: "",
    },
  ]);
  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);
  };
  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);

  const handleShow1 = (id, cat, ridc, cltc, clientOnline) => {
    setalledit({
      category: cat,
      _id: id,
      RiderCommission: ridc,
      clintaddcommission: cltc,
      ClientCommissionOnline: clientOnline,
    });
    setShow1(true);
  };
  const [show, setShow] = useState(false);

  const handleClose11 = () => setShow11(false);

  const handleShow11 = (id) => {
    setcid(id);
    setShow11(true);
  };
  const [show11, setShow11] = useState(false);
  const objectArray1 = [
    { category: "Go_Movers" },
    { category: "Go_Food" },
    // { category: "Grossary", },
    { category: "Go_Taxi" },
  ];
  const selection1 = (selectedValues) => {
    setCategory(selectedValues);
  };
  const selection11 = (selectedValues) => {
    // alert(JSON.stringify(selectedValues[0].category))
    setalledit((prevStyle) => ({
      ...prevStyle,
      category: selectedValues[0].category,
    }));
  };
  function getCommision() {
    axios
      .get(Baseurl.baseurl + "/go-pricing/get-commission")

      .then((response) => {
        setSpinner(false);
        setallclintcomminission(response.data.commission);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  useEffect(() => {
    getCommision();
  }, []);

  const addcomminission = (e) => {
    e.preventDefault();
    var data = {
      Category: category[0].category,
      RiderCommission: riderCommission,
      ClientCommissionCOD: 0,
      ClientCommissionOnline: clientCommisionOnline,
    };
    axios
      .post(Baseurl.baseurl + "/go-pricing/add-commission", data)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { button: "Done" });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" });
        }
        getCommision();
        handleClose();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };

  const editaddcomminission = (e) => {
    e.preventDefault();
    var data = {
      Category: edit.category,
      RiderCommission: edit.RiderCommission,
      ClientCommissionCOD: 0,
      ClientCommissionOnline: edit.ClientCommissionOnline,
    };

    var id = edit._id;
    axios
      .put(Baseurl.baseurl + `/go-pricing/update-commission/${id}`, data)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { button: "Done" });
          getCommision();
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" });
        }
        handleClose11();
        setShow1(false);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };
  const deleteaddcomminission = (e) => {
    e.preventDefault();
    var id = cid;

    axios
      .delete(Baseurl.baseurl + `/go-pricing/delete-commission/${id}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", { button: "Done" });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" });
        }
        getCommision();
        handleClose11();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };
  return (
    <Col lg={12}>
      <Modal size="" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Commission</Modal.Title>
        </Modal.Header>
        <form onSubmit={(e) => addcomminission(e)}>
          <Modal.Body>
            <div className="col-sm-12 mb-5" id="multiselect">
              <label>Category</label>
              <Multiselect
                options={objectArray1}
                singleSelect
                displayValue="category"
                onSelect={selection1}
              />
            </div>

            <div className="col-auto">
              <label>Rider Commission</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="enter percentage"
                  value={riderCommission}
                  onChange={(e) => setridercommission(e.target.value)}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>

            {/* <div className="col-auto">
              <label>Clint Commission(COD)</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="enter percentage"
                  value={clintaddcommission}
                  onChange={(e) => setclintcommission(e.target.value)}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div> */}
            <div className="col-auto">
              <label>Clint Commission(ONLINE)</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-cont rol"
                  placeholder="enter percentage"
                  value={clientCommisionOnline}
                  onChange={(e) => setClientCommisionOnline(e.target.value)}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button type="submit">Add</Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal size="" show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>Update Commission</Modal.Title>
        </Modal.Header>
        <form onSubmit={(e) => editaddcomminission(e)}>
          <Modal.Body>
            <div className="col-sm-12 mb-5" id="multiselect">
              <label>Category</label>

              <Multiselect
                options={objectArray1}
                displayValue="category"
                singleSelect
                selectedValues={[
                  {
                    category: edit.category,
                  },
                ]}
                onSelect={selection11}
              />
            </div>

            <div className="col-auto">
              <label>Rider Commission</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00"
                  // value={Base_Fare}
                  defaultValue={edit.RiderCommission}
                  onChange={(event) => {
                    setalledit((prevStyle) => ({
                      ...prevStyle,
                      RiderCommission: event.target.value,
                    }));
                  }}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>

            {/* <div className="col-auto">
              <label>Clint Commission(COD)</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00"
                  // value={Base_Fare}
                  defaultValue={edit.clintaddcommission}
                  onChange={(event) => {
                    setalledit((prevStyle) => ({
                      ...prevStyle,
                      clintaddcommission: event.target.value,
                    }));
                  }}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div> */}
            <div className="col-auto">
              <label>Clint Commission(Online)</label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00"
                  // value={Base_Fare}
                  defaultValue={edit.ClientCommissionOnline}
                  onChange={(event) => {
                    setalledit((prevStyle) => ({
                      ...prevStyle,
                      ClientCommissionOnline: event.target.value,
                    }));
                  }}
                  required
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose1}>
              Close
            </Button>
            <Button type="submit">Update</Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal size="" show={show11} onHide={handleClose11}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Commission</Modal.Title>
        </Modal.Header>
        <form onSubmit={(e) => deleteaddcomminission(e)}>
          <Modal.Body>
            <h4>Sure you want to delete the commission</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit">Yes</Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <Card.Title className="text-white">
            Riders/Clint Commission
          </Card.Title>
          <button className="btn btn-primary" onClick={() => handleShow()}>
            Add Commission
          </button>
          <div className="input-group search-area d-lg-inline-flex d-none">
            <div className="input-group-append">
              <button className="input-group-text">
                <i className="flaticon-381-search-2" />
              </button>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
            />
          </div>
        </Card.Header>
        <Card.Body>
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table responsive className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong>SL No.</strong>
                  </th>
                  <th>
                    <strong> Category</strong>
                  </th>
                  <th>
                    <strong>Rider Commission</strong>
                  </th>
                  {/* <th>
                    <strong>Clint Commission(COD)</strong>
                  </th> */}
                  <th>
                    <strong>Clint Commission(ONLINE)</strong>
                  </th>
                  <th>
                    <strong>Actions</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {clintcommission &&
                  clintcommission.map((d, i) => (
                    <tr>
                      <td>
                        <strong>{i + 1}</strong>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="w-space-no">{d.Category}</span>
                        </div>
                      </td>
                      <td>{d.RiderCommission} </td>
                      {/* <td>{d.ClientCommissionCOD} </td> */}
                      <td>{d.ClientCommissionOnline} </td>

                      <td className="col-sm-3">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            handleShow1(
                              d._id,
                              d.Category,
                              d.RiderCommission,
                              d.ClientCommissionCOD,
                              d.ClientCommissionOnline
                            );
                          }}
                        >
                          Update
                        </button>
                        <button
                          className="btn btn-primary ml-1"
                          onClick={() => {
                            handleShow11(d._id);
                          }}
                        >
                          Delete
                        </button>{" "}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
          {!clintcommission && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Add Commission
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RiderCommission;
